import { defineAsyncComponent } from 'vue';

export const KUBER_DETAIL = {
  NODE_LIST: 'Node List',
  NAMESPACE_LIST: 'Namespace List',
  POD_LIST: 'Pod List',
  SERVICE_OBJECT_LIST: 'Service Object List',
  INGRESS_LIST: 'Ingress List',
  PERSISTENT_VOLUMES_LIST: 'Persistent Volumes List',
  PERSISTENT_VOLUMES_CLAIMS_LIST: 'Persistent Volumes Claims List',
  STORAGE_CLASSES_LIST: 'Storage Classes List',
  NAMESPACE: 'Namespace',
  POD: 'Pod',
  NODE: 'Node',
  CRON_JOB: 'CronJobs',
  OWNER_REFERENCES: 'Owner References',
  DEPLOYMENT: 'Deployments',
  STATEFUL_SET: 'Stateful Sets',
  DAEMON_SET: 'Daemon Sets',
  JOB: 'Job',
  REPLICA_SET: 'Replica Sets',
  SERVICE: 'Service',
  ROLES_BINDINGS: 'Role Binding',
  SERVICE_ACCOUNTS: 'Service Accounts',
  ROLES: 'Role',
  INGRESS: 'Ingress',
  OPENSHIFT_ROUTE: 'OpenShift Route',
  VIRTUAL_SERVICE: 'Virtual Service',
  CONFIG_MAPS: 'ConfigMaps',
  PERSISTENT_VOLUMES_CLAIMS: 'Persistent Volumes Claims',
  STORAGE_CLASSES: 'Storage Classes',
  CLUSTER_ROLES: 'Cluster Roles',
  CLUSTER_ROLES_BINDINGS: 'Cluster Role Binding',
  PERSISTENT_VOLUMES: 'Persistent Volumes',
  HPA: 'HPA',
  RESOURCE_INVENTORY_SERVICE: 'Resource Inventory Service',
  RESOURCE_INVENTORY_INGRESS: 'Resource Inventory Ingress',
  RESOURCE_INVENTORY_ROUTE: 'Resource Inventory Route',
  RESOURCE_INVENTORY_VIRTUAL_SERVICE: 'Resource Inventory Virtual Service',
} as const;

export const PA_KUBER_DETAIL = {
  EVENT: 'Event',
  HISTORY_MANAGEMENT: 'History Management',
} as const;

export const INFRA_DETAIL = {
  HOST: 'Host',
  NETWORK_DEVICE: 'Network Device',
  PROCESS_DETAIL: 'Process Detail',
  NETWORK_DETAIL: 'Network Detail',
  DISK_DETAIL: 'Disk Detail',
  GPU_DETAIL: 'GPU Detail',
  NETWORK_OBJECT: 'Network Object',
  SCRIPT_DETAIL: 'Script',
} as const;

export const CONTAINER_DETAIL = {
  K8S_CONTAINER: 'K8s Container',
  CONTAINER_HOST: 'Container Host',
} as const;

export const KAFKA_DETAIL = {
  KAFKA_CLUSTER: 'Kafka Cluster',
  KAFKA_BROKER: 'Kafka Broker',
  KAFKA_TOPIC: 'Kafka Topic',
} as const;
export const MESSAGE_QUEUE_DETAIL = {
  ...KAFKA_DETAIL,
} as const;

export const APPLICATION_DETAIL = {
  WAS: 'WAS',
  WEB_SERVER: 'Web Server',
  TRANSACTION: 'Transaction',
  TRANSACTION_INFO: 'Transaction Info',
  ACTIVE_TRANSACTION: 'Active Transaction',
  WEB_APPLICATION: 'Web Application',
  WEB_APPLICATION_PAGE_ANALYSIS: 'Web Application Page Analysis',
  AJAX_REQUEST_HISTORY: 'Ajax Request History',
  URL_MONITORING: 'URL',
  BROWSER_ERROR_TRACKING: 'Browser Error Tracking',
  PAGE_PERFORMANCE_MONITORING: 'Page Performance Monitoring',
  USER_MONITORING_SESSION_ANALYSIS: 'User Monitoring Session Analysis',
  USER_MONITORING_SESSION_REPLAY: 'User Monitoring Session Replay',
  USER_MONITORING_USER_EVENT: 'User Monitoring User Event',
} as const;

export const ALERT_DETAIL = {
  ALERT: 'Alert',
  EVENT_ALERT: 'Event Alert',
} as const;

export const SERVICE_DETAIL = {
  SERVICE_LIST: 'Business List',
} as const;

export const DATABASE_DETAIL = {
  INSTANCE: 'Instance',
  SESSION: 'Session',
  SQL: 'SQL',
  PARAMETER: 'Parameter',
  CLUSTER: 'Cluster',
  BROKER: 'Broker',
  SHARDED_CLUSTER: 'Sharded Cluster',
  KEY_BROWSER: 'Key',
  OBJECT: 'Object',
  REPLICATION: 'Replication',
  REPLICATION_OBJECT: 'Replication Detail',
  SLOW_QUERY: 'Slow Query',
  ACTIVE_QUERY: 'Active Query',
} as const;

export const TOOL_DETAIL = {
  QUERY: 'Query',
} as const;

export const CONFIG_DETAIL = {
  AGENT: 'Agent',
  EXECUTION: 'Execution',
  USAGE_TREND: 'Usage Trend',
  CLOUD_ACCOUNT: 'Account_2',
  DATA_COLLECTION: 'Collection',
  EOL_EOS_POLICY: 'EOL/EOS Policy',
} as const;

export const CLOUD_SERVICE_DETAIL = {
  CLOUD_COMPUTING: 'Cloud Computing',
  CLOUD_STORAGE: 'Cloud Storage',
  CLOUD_DATABASE: 'Cloud Database',
  AWS_EC2: 'AWS EC2',
  AWS_LAMBDA: 'AWS Lambda',
  AWS_S3: 'AWS S3',
  AWS_DOCUMENTDB: 'AWS DocumentDb',
  AWS_DYNAMODB: 'AWS DynamoDB',
  AWS_ELASTICACHE_CLUSTER: 'AWS ElastiCache Cluster',
  AWS_ELASTICACHE_SERVERLESS: 'AWS ElastiCache Serverless',
  AWS_ELASTICACHE_SHARD: 'AWS ElastiCache Shard',
  AWS_ELASTICACHE_NODE: 'AWS ElastiCache Node',
  AWS_RDS: 'AWS RDS',
  AWS_DMS_TASK: 'AWS DMS Task',
  AWS_DMS_REPLINSTANCE: 'AWS DMS Replication Instance',
  AWS_REDSHIFT: 'AWS Redshift',
} as const;

export const CUSTOM_DETAIL = {
  CUSTOM: 'CUSTOM',
} as const;

export const HOME_DETAIL = {
  ALERT_HISTORY: 'ALERT_HISTORY',
  CURRENT_ALERT: 'CURRENT_ALERT',
} as const;

export const LOG_DETAIL = {
  LOG: 'Log',
  KEYWORD_LOG: 'Keyword Log',
  DETAILED_LOG_ANALYSIS: 'Detailed Log Analysis',
} as const;

export const AIOPS_DETAIL = {
  INSIGHT: 'AIOps Insight',
  INSIGHT_ROOT_CAUSE: 'AIOps Insight Root Cause',
} as const;

export const DETAIL_COMPONENTS = {
  // cluster topology - list detail
  [KUBER_DETAIL.NODE_LIST]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/listDetail/NodeListDetail.vue'),
    ),
  },
  [KUBER_DETAIL.NAMESPACE_LIST]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/listDetail/NamespaceListDetail.vue'),
    ),
  },
  [KUBER_DETAIL.POD_LIST]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/listDetail/PodListDetail.vue'),
    ),
  },
  [KUBER_DETAIL.SERVICE_OBJECT_LIST]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/listDetail/ServiceListDetail.vue'),
    ),
  },
  [KUBER_DETAIL.INGRESS_LIST]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/listDetail/IngressListDetail.vue'),
    ),
  },
  [KUBER_DETAIL.PERSISTENT_VOLUMES_CLAIMS_LIST]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/listDetail/PvcListDetail.vue'),
    ),
  },
  [KUBER_DETAIL.PERSISTENT_VOLUMES_LIST]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/listDetail/PvListDetail.vue'),
    ),
  },
  [KUBER_DETAIL.STORAGE_CLASSES_LIST]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/listDetail/ScListDetail.vue'),
    ),
  },
  // kuber
  [KUBER_DETAIL.NAMESPACE]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/namespaceDetail/NamespaceDetail.vue'),
    ),
  },
  [KUBER_DETAIL.POD]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/podsListDetail/PodsListDetail.vue'),
    ),
  },
  [KUBER_DETAIL.NODE]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/nodeDetail/NodeDetail.vue'),
    ),
  },
  [KUBER_DETAIL.SERVICE]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/serviceDetail/ServiceDetail.vue'),
    ),
  },
  [KUBER_DETAIL.DEPLOYMENT]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/deploymentsDetail/DeploymentsDetail.vue'),
    ),
  },
  [KUBER_DETAIL.STATEFUL_SET]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/statefulSetsDetail/StatefulSetsDetail.vue'),
    ),
  },
  [KUBER_DETAIL.REPLICA_SET]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/replicaSetsDetail/ReplicaSetsDetail.vue'),
    ),
  },
  [KUBER_DETAIL.DAEMON_SET]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/daemonSetsDetail/DaemonSetsDetail.vue'),
    ),
  },
  [KUBER_DETAIL.ROLES_BINDINGS]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/rolesBindingsDetail/RolesBindingsDetail.vue'),
    ),
  },
  [KUBER_DETAIL.ROLES]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/rolesDetail/RolesDetail.vue'),
    ),
  },
  [KUBER_DETAIL.HPA]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/hpaDetail/HpaDetail.vue'),
    ),
  },
  [KUBER_DETAIL.JOB]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/jobsDetail/JobsDetail.vue'),
    ),
  },
  [KUBER_DETAIL.INGRESS]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/ingressDetail/IngressDetail.vue'),
    ),
  },
  [KUBER_DETAIL.OPENSHIFT_ROUTE]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/openshiftRouteDetail/openshiftRouteDetail.vue'),
    ),
  },
  [KUBER_DETAIL.VIRTUAL_SERVICE]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/virtualServiceDetail/VirtualServiceDetail.vue'),
    ),
  },
  [KUBER_DETAIL.CRON_JOB]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/cronJobsDetail/CronJobsDetail.vue'),
    ),
  },
  [KUBER_DETAIL.SERVICE_ACCOUNTS]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/serviceAccountsDetail/ServiceAccountsDetail.vue'),
    ),
  },
  [KUBER_DETAIL.CONFIG_MAPS]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/configMapsDetail/ConfigMapsDetail.vue'),
    ),
  },
  [KUBER_DETAIL.STORAGE_CLASSES]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/storageClassesDetail/StorageClassesDetail.vue'),
    ),
  },
  [KUBER_DETAIL.CLUSTER_ROLES]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/clusterRolesDetail/ClusterRolesDetail.vue'),
    ),
  },
  [KUBER_DETAIL.CLUSTER_ROLES_BINDINGS]: {
    component: defineAsyncComponent(
      () =>
        import('@/kubernetes/components/clusterRolesBindingsDetail/ClusterRolesBindingsDetail.vue'),
    ),
  },
  [KUBER_DETAIL.PERSISTENT_VOLUMES]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/persistentVolumesDetail/PersistentVolumesDetail.vue'),
    ),
  },
  [KUBER_DETAIL.PERSISTENT_VOLUMES_CLAIMS]: {
    component: defineAsyncComponent(
      () =>
        import('@/kubernetes/components/persistentVolumesClaimsDetail/PersistentVolumesClaimsDetail.vue'),
    ),
  },
  [KUBER_DETAIL.RESOURCE_INVENTORY_SERVICE]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/resourceInventoryDetail/ServiceDetail.vue'),
    ),
  },
  [KUBER_DETAIL.RESOURCE_INVENTORY_INGRESS]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/resourceInventoryDetail/IngressDetail.vue'),
    ),
  },
  [KUBER_DETAIL.RESOURCE_INVENTORY_ROUTE]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/resourceInventoryDetail/RouteDetail.vue'),
    ),
  },
  [KUBER_DETAIL.RESOURCE_INVENTORY_VIRTUAL_SERVICE]: {
    component: defineAsyncComponent(
      () => import('@/kubernetes/components/resourceInventoryDetail/VirtualServiceDetail.vue'),
    ),
  },
  [PA_KUBER_DETAIL.EVENT]: {
    component: defineAsyncComponent(
      () => import('@/kubernetesAnalysis/components/eventDetail/EventDetail.vue'),
    ),
  },
  [PA_KUBER_DETAIL.HISTORY_MANAGEMENT]: {
    component: defineAsyncComponent(
      () =>
        import('@/kubernetesAnalysis/components/historyManagementDetail/HistoryManagementDetail.vue'),
    ),
  },
  // infra
  [INFRA_DETAIL.HOST]: {
    component: defineAsyncComponent(
      () => import('@/infrastructure/views/hostView/hostDetail/HostDetail.vue'),
    ),
  },
  [INFRA_DETAIL.NETWORK_DEVICE]: {
    component: defineAsyncComponent(
      () =>
        import('@/infrastructure/views/networkDeviceView/networkDeviceDetail/NetworkDeviceDetail.vue'),
    ),
  },
  [INFRA_DETAIL.PROCESS_DETAIL]: {
    component: defineAsyncComponent(
      () => import('@/infrastructure/views/hostView/hostDetail/ProcessDetail.vue'),
    ),
  },
  [INFRA_DETAIL.NETWORK_DETAIL]: {
    component: defineAsyncComponent(
      () => import('@/infrastructure/views/hostView/hostDetail/NetworkDetail.vue'),
    ),
  },
  [INFRA_DETAIL.DISK_DETAIL]: {
    component: defineAsyncComponent(
      () => import('@/infrastructure/views/hostView/hostDetail/DiskDetail.vue'),
    ),
  },
  [INFRA_DETAIL.GPU_DETAIL]: {
    component: defineAsyncComponent(() => import('@/gpu/views/gpuDetail/GpuDetail.vue')),
  },
  [INFRA_DETAIL.NETWORK_OBJECT]: {
    component: defineAsyncComponent(
      () => import('@/infrastructure/views/npm/networkObject/NetworkObjectDetail.vue'),
    ),
  },
  [INFRA_DETAIL.SCRIPT_DETAIL]: {
    component: defineAsyncComponent(
      () =>
        import('@/infrastructure/views/scriptManagerHistoryView/scriptManagerHistoryDetail/ScriptManagerHistoryDetail.vue'),
    ),
  },
  // container
  [CONTAINER_DETAIL.CONTAINER_HOST]: {
    component: defineAsyncComponent(
      () => import('@/infrastructure/views/containerView/containerDetail/ContainerDetail.vue'),
    ),
  },
  [CONTAINER_DETAIL.K8S_CONTAINER]: {
    component: defineAsyncComponent(
      () => import('@/infrastructure/views/containerView/containerDetail/ContainerDetail.vue'),
    ),
  },
  // message-queue
  [MESSAGE_QUEUE_DETAIL.KAFKA_CLUSTER]: {
    component: defineAsyncComponent(
      () => import('@/messageQueue/views/kafka/kafkaDetail/KafkaClusterDetail.vue'),
    ),
  },
  [MESSAGE_QUEUE_DETAIL.KAFKA_BROKER]: {
    component: defineAsyncComponent(
      () => import('@/messageQueue/views/kafka/kafkaDetail/KafkaBrokerDetail.vue'),
    ),
  },
  [MESSAGE_QUEUE_DETAIL.KAFKA_TOPIC]: {
    component: defineAsyncComponent(
      () => import('@/messageQueue/views/kafka/kafkaDetail/KafkaTopicDetail.vue'),
    ),
  },
  // application
  [APPLICATION_DETAIL.WAS]: {
    component: defineAsyncComponent(
      () => import('@/application/components/wasDetail/WasDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.WEB_SERVER]: {
    component: defineAsyncComponent(
      () => import('@/application/components/webServerDetail/WebServerDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.TRANSACTION]: {
    component: defineAsyncComponent(
      () => import('@/application/components/transactionDetail/TransactionDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.TRANSACTION_INFO]: {
    component: defineAsyncComponent(
      () => import('@/application/components/transactionInfoDetail/TransactionInfoDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.ACTIVE_TRANSACTION]: {
    component: defineAsyncComponent(
      () => import('@/application/components/activeTransactionDetail/ActiveTransactionDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.URL_MONITORING]: {
    component: defineAsyncComponent(
      () => import('@/application/components/urlMonitoringDetail/UrlMonitoringDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.AJAX_REQUEST_HISTORY]: {
    component: defineAsyncComponent(
      () =>
        import('@/application/components/ajaxRequestHistoryDetail/AjaxRequestHistoryDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.WEB_APPLICATION_PAGE_ANALYSIS]: {
    component: defineAsyncComponent(
      () => import('@/application/components/pageAnalysisDetail/PageAnalysisDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.WEB_APPLICATION]: {
    component: defineAsyncComponent(
      () => import('@/application/components/webApplicationDetail/WebApplicationDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.BROWSER_ERROR_TRACKING]: {
    component: defineAsyncComponent(
      () =>
        import('@/application/components/browserErrorTrackingDetail/BrowserErrorTrackingDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.PAGE_PERFORMANCE_MONITORING]: {
    component: defineAsyncComponent(
      () => import('@/application/components/pagePerformanceDetail/PagePerformanceDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.USER_MONITORING_SESSION_ANALYSIS]: {
    component: defineAsyncComponent(
      () => import('@/application/components/sessionAnalysisDetail/SessionAnalysisDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.USER_MONITORING_SESSION_REPLAY]: {
    component: defineAsyncComponent(
      () => import('@/application/components/sessionReplayDetail/SessionReplayDetail.vue'),
    ),
  },
  [APPLICATION_DETAIL.USER_MONITORING_USER_EVENT]: {
    component: defineAsyncComponent(
      () => import('@/application/components/userEventDetail/UserEventDetail.vue'),
    ),
  },
  [ALERT_DETAIL.ALERT]: {
    component: defineAsyncComponent(() => import('@/alert/components/alertDetail/AlertDetail.vue')),
  },
  [ALERT_DETAIL.EVENT_ALERT]: {
    component: defineAsyncComponent(
      () => import('@/alert/components/eventAlertDetail/EventAlertDetail.vue'),
    ),
  },
  [SERVICE_DETAIL.SERVICE_LIST]: {
    component: defineAsyncComponent(
      () => import('@/service/views/serviceView/serviceDetail/ServiceDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.INSTANCE]: {
    component: defineAsyncComponent(
      () => import('@/database/components/instanceDetail/InstanceDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.SQL]: {
    component: defineAsyncComponent(
      () => import('@/database/components/sqlDetail/InstanceSqlDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.SLOW_QUERY]: {
    component: defineAsyncComponent(
      () => import('@/database/components/slowQuery/slowQuerySqlDetail/SlowQuerySqlDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.ACTIVE_QUERY]: {
    component: defineAsyncComponent(
      () => import('@/database/components/activeQueryDetail/ActiveQueryDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.SESSION]: {
    component: defineAsyncComponent(
      () => import('@/database/components/sessionDetail/InstanceSessionDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.PARAMETER]: {
    component: defineAsyncComponent(
      () => import('@/database/components/parameterDetail/InstanceParameterDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.CLUSTER]: {
    component: defineAsyncComponent(
      () => import('@/database/components/clusterDetail/InstanceClusterDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.BROKER]: {
    component: defineAsyncComponent(
      () => import('@/database/components/brokerDetail/BrokerDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.SHARDED_CLUSTER]: {
    component: defineAsyncComponent(
      () => import('@/database/components/instanceDetail/InstanceDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.KEY_BROWSER]: {
    component: defineAsyncComponent(
      () => import('@/database/components/keyBrowserDetail/KeyBrowserDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.OBJECT]: {
    component: defineAsyncComponent(
      () => import('@/database/components/objectDetail/ObjectDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.REPLICATION]: {
    component: defineAsyncComponent(
      () => import('@/database/components/replicationDetail/InstanceReplicationDetail.vue'),
    ),
  },
  [DATABASE_DETAIL.REPLICATION_OBJECT]: {
    component: defineAsyncComponent(
      () => import('@/altibase/components/replicationObjectDetail/ReplicationObjectDetail.vue'),
    ),
  },

  [TOOL_DETAIL.QUERY]: {
    component: defineAsyncComponent(() => import('@/tool/components/queryDetail/QueryDetail.vue')),
  },

  // Config
  [CONFIG_DETAIL.USAGE_TREND]: {
    component: defineAsyncComponent(
      () => import('@/config/views/management/data/components/UsageTrendSlide.vue'),
    ),
  },
  [CONFIG_DETAIL.DATA_COLLECTION]: {
    component: defineAsyncComponent(
      () => import('@/config/views/management/data/components/DataCollectionSlide.vue'),
    ),
  },
  [CONFIG_DETAIL.AGENT]: {
    component: defineAsyncComponent(
      () => import('@/config/components/agentDetail/AgentDetail.vue'),
    ),
  },
  [CONFIG_DETAIL.EXECUTION]: {
    component: defineAsyncComponent(
      () => import('@/config/components/executionDetail/ExecutionDetail.vue'),
    ),
  },
  [CONFIG_DETAIL.CLOUD_ACCOUNT]: {
    component: defineAsyncComponent(
      () => import('@/config/views/platform/cloud/component/accountDetail/AccountDetail.vue'),
    ),
  },
  [CONFIG_DETAIL.EOL_EOS_POLICY]: {
    component: defineAsyncComponent(
      () => import('@/config/views/assetManagement/eolEos/eolPolicy/detail/EolPolicyDetail.vue'),
    ),
  },

  // Cloud
  [CLOUD_SERVICE_DETAIL.CLOUD_COMPUTING]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.CLOUD_STORAGE]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.CLOUD_DATABASE]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_EC2]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_LAMBDA]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_S3]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_DOCUMENTDB]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_DYNAMODB]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_ELASTICACHE_CLUSTER]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_ELASTICACHE_SHARD]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_ELASTICACHE_NODE]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_ELASTICACHE_SERVERLESS]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_RDS]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_DMS_TASK]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_DMS_REPLINSTANCE]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  [CLOUD_SERVICE_DETAIL.AWS_REDSHIFT]: {
    component: defineAsyncComponent(
      () => import('@/cloud/components/cloudServiceDetail/CloudServiceDetail.vue'),
    ),
  },
  // Home
  [HOME_DETAIL.ALERT_HISTORY]: {
    component: defineAsyncComponent(
      () => import('@/home/components/AlertHistoryDetail/AlertHistoryDetail.vue'),
    ),
  },
  // Log
  [LOG_DETAIL.LOG]: {
    component: defineAsyncComponent(() => import('@/logs/components/logDetail/LogDetail.vue')),
  },
  [LOG_DETAIL.DETAILED_LOG_ANALYSIS]: {
    component: defineAsyncComponent(
      () => import('@/logs/components/detailedLogAnalysisDetail/DetailedLogAnalysisDetail.vue'),
    ),
  },
  [LOG_DETAIL.KEYWORD_LOG]: {
    component: defineAsyncComponent(
      () => import('@/logs/components/keywordLogDetail/KeywordLogDetail.vue'),
    ),
  },
  // AIOps
  [AIOPS_DETAIL.INSIGHT]: {
    component: defineAsyncComponent(
      () => import('@/aiops/components/insightDetail/InsightDetail.vue'),
    ),
  },
  [AIOPS_DETAIL.INSIGHT_ROOT_CAUSE]: {
    component: defineAsyncComponent(
      () => import('@/aiops/components/insightRootCauseDetail/InsightRootCauseDetail.vue'),
    ),
  },
};
